<template>
  <div>
    <v-row>
      <v-col class="mx-auto">
        <!--  max-width="650px" class="align-center justify-center pa-0 mb-8 mx-auto" -->
        <v-card flat>
          <ValidationObserver mode="passive" ref="form" v-slot="{ invalid, passes }">
            <v-form>
              <v-card-title v-if="isStage()" class="red--text my-12">
                !! STAGE !!
              </v-card-title>
              <v-card-subtitle class="oceanblau--text text-h4 text-uppercase pl-3" v-html="$t('register.form.title')"> </v-card-subtitle>
              <v-card-text>
                <!-- COMPANY NAME -->
                <ValidationProvider vid="companynameValid" v-slot="{ errors }">
                  <VTextFieldWithValidation clearable rules="required" v-model="visitorcompanyname" :label="$t('register.form.lev1.label')" :error="errors.length > 0" />
                  <span class="red--text">{{ errors[0] }}</span>
                </ValidationProvider>

                <!-- E-MAIL -->
                <VTextFieldWithValidation vid="confirmation" clearable rules="required|email" v-model="visitoremail" :label="$t('register.form.lev2.email')" hint="format name@company.com" />

                <!-- Confirm E-MAIL -->
                <VTextFieldWithValidation clearable rules="required|email|confirmed:confirmation" v-model="visitoremailConfirm" :label="$t('register.form.lev2.emailConfirm')" hint="format name@company.com" />

                <!-- FIRST NAME -->
                <VTextFieldWithValidation clearable rules="required" v-model="visitorfirstname" :label="$t('register.form.lev2.firstName')" />

                <!-- LAST NAME -->
                <VTextFieldWithValidation clearable rules="required" v-model="visitorlastname" :label="$t('register.form.lev2.lastName')" />

                <v-row>
                  <v-col cols="4">
                    <!-- POSTCODE -->
                    <VTextFieldWithValidation clearable rules="required" v-model="visitorpostcode" :label="$t('register.form.lev2.postcode')" />
                  </v-col>

                  <v-col cols="8">
                    <!-- STREET -->
                    <VTextFieldWithValidation clearable rules="required" v-model="visitorstreet" :label="$t('register.form.lev2.street')" />
                  </v-col>
                </v-row>

                <!-- CITY -->
                <VTextFieldWithValidation clearable rules="required" v-model="visitorcity" :label="$t('register.form.lev2.city')" />

                <!-- COUNTRY -->
                <VSelectWithValidation clearable rules="required" :items="countryItems" v-model="visitorCountry" :label="$t('register.form.lev3.country')" item-text="name" item-value="value" />

                <!-- BECOME AWARE OF -->
                <VSelectWithValidation clearable rules="required" :items="partnerList" v-model="visitorBecomeAwareOf" :label="$t('register.form.lev3.becomeAwareOf')" item-text="name" item-value="value" />

                <!-- APPROVAL -->
                <div class="my-6">
                  <div class="h6">{{ $t("agree") }}:</div>
                  <VCheckboxWithValidation v-model="visitorAccepted_1" :checkboxText="$t('register.form.confirm.dataprotectionKISManager')" :checkboxLink="$t('register.form.confirm.dataprotectionKISManagerLink')"> </VCheckboxWithValidation>

                  <VCheckboxWithValidation v-model="visitorAccepted_3" :checkboxText="$t('register.form.confirm.termsAndConditions')" :checkboxLink="$t('register.form.confirm.termsAndConditionsLink')"> </VCheckboxWithValidation>
                </div>

                <span class="lighten-1" v-html="$t('register.form.confirm.note')" style="font-size: 12px"></span>
              </v-card-text>

              <!-- ALERT -->
              <v-alert v-show="$store.state.visitors.showError" type="error">{{ $store.state.visitors.errorMessage }}</v-alert>

              <!-- SEND Button -->
              <v-card-actions>
                <v-row class="mx-auto">
                  <v-col cols="7" sm="8">
                    <v-text-field :hint="$t('spamProtection.description')" v-model="spamProtectionEntry" outlined class="rafiTextField" dense @input="spamProtectionAnswerChanged">
                      <template v-slot:prepend-inner>
                        <span class="text-no-wrap mt-1 mr-2">{{ $t("spamProtection.label") }} {{ spamProtectionAnswer.summandLeft }} + {{ spamProtectionAnswer.summandRight }} =</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn elevation="0" tile class="rafiButton petrol white--text mt-1" :loading="iswaitingForBackend" @click="passes(register)" :disabled="!visitorAccepted_1 || !visitorAccepted_3 || invalid || !spamProtectionAnswerValid">
                      {{ $t("register.form.lev1.button") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VTextFieldWithValidation from "../../inputs/VTextFieldWithValidation";
import VSelectWithValidation from "../../inputs/VSelectWithValidation";
import VCheckboxWithValidation from "../../inputs/VCheckboxWithValidation";
import PortalService from "./../../services/PortalService";
import { mapState, mapActions, mapGetters } from "vuex";
import i18n from "../../i18n";
import subtenant from "@/services/subtenants";

export default {
  extends: PortalService,
  async mounted() {
    await this.loadPartner();

    this.spamProtectionAnswer.summandLeft = this.getRandomInt();
    this.spamProtectionAnswer.summandRight = this.getRandomInt();
  },
  beforeDestroy() {
    this.visitorlastname = "";
  },
  data() {
    return {
      partnerList: [],
      iswaitingForBackend: false,
      spamProtectionAnswerValid: false,
      spamProtectionAnswer: {
        summandLeft: 3,
        summandRight: 7,
        sum: 0,
      },
      spamProtectionEntry: null,
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    VTextFieldWithValidation,
    VSelectWithValidation,
    VCheckboxWithValidation,
  },
  name: "registerSubtenant",
  computed: {
    ...mapState("visitors", ["companyname", "firstname", "lastname", "email", "emailConfirm", "street", "postcode", "city", "country", "becomeAwareOf", "accepted_1", "accepted_3"]),
    ...mapGetters("visitors", ["countryItems"]),
    visitorcompanyname: {
      get() {
        return this.companyname;
      },
      set(value) {
        this.setCompanyName(value);
      },
    },
    visitorfirstname: {
      get() {
        return this.firstname;
      },
      set(value) {
        this.setFirstName(value);
      },
    },
    visitorlastname: {
      get() {
        return this.lastname;
      },
      set(value) {
        this.setLastName(value);
      },
    },
    visitorstreet: {
      get() {
        return this.street;
      },
      set(value) {
        this.setStreet(value);
      },
    },
    visitorpostcode: {
      get() {
        return this.postcode;
      },
      set(value) {
        this.setPostcode(value);
      },
    },
    visitorcity: {
      get() {
        return this.city;
      },
      set(value) {
        this.setCity(value);
      },
    },
    visitoremail: {
      get() {
        return this.email;
      },
      set(value) {
        this.setEmail(value);
      },
    },
    visitoremailConfirm: {
      get() {
        return this.emailConfirm;
      },
      set(value) {
        this.setEmailConfirm(value);
      },
    },
    visitorCountry: {
      get() {
        return this.country;
      },
      set(value) {
        this.setCountry(value);
      },
    },
    visitorBecomeAwareOf: {
      get() {
        return this.becomeAwareOf;
      },
      set(value) {
        this.setBecomeAwareOf(value);
      },
    },
    visitorAccepted_1: {
      get() {
        return this.accepted_1;
      },
      set(value) {
        this.setAccepted_1(value);
      },
    },
    visitorAccepted_3: {
      get() {
        return this.accepted_3;
      },
      set(value) {
        this.setAccepted_3(value);
      },
    },
  },
  methods: {
    ...mapActions("visitors", ["setCompanyName", "setFirstName", "setLastName", "setEmail", "setEmailConfirm", "setBecomeAwareOf", "setStreet", "setPostcode", "setCity", "setCountry", "setAccepted_1", "setAccepted_3", "resetData"]),
    async loadPartner() {
      this.partnerList = await subtenant.LoadPartnerList();

      //now sort the list alphabetic
      //data is a string array like this: ["A4 GmbH","Algorithmx Automation GmbH","BeeWaTec AG","KruCon | Markus Krüger Unternehmensberatung","RAFI GmbH & Co. KG","CONTROLINTECH","bm.engineering GmbH","Sibalco AG"]
      let sortedList = this.partnerList.sort(function(a, b) {
        return a.localeCompare(b, undefined, { sensitivity: "base" });
      });

      //append translated default element ('None of the above')
      let translatedList = i18n.t(`store.visitor.becomeAwareOf`);
      this.partnerList.push(...translatedList);

      this.partnerList = sortedList;
    },
    isStage() {
      return process.env.VUE_APP_SLOT == "Stage";
    },
    getRandomInt() {
      return Math.floor(Math.random() * Math.floor(10));
    },
    async register() {
      this.$store.state.visitors.errorMessage = "";
      this.$store.state.visitors.showError = false;

      // start spinner
      this.iswaitingForBackend = true;

      try {
        //function from extended PortalService
        let accountExists = await this.companyNameExists(this.visitorcompanyname);

        if (accountExists == null) {
          this.iswaitingForBackend = false;
          return;
        }

        if (accountExists) {
          //create error message
          this.$refs.form.setErrors({
            companynameValid: [this.$t("register.form.lev1.accountExists")],
          });
          this.iswaitingForBackend = false;
          this.$store.state.visitors.showError = true;
          this.$store.state.visitors.errorMessage = this.$t("register.form.lev1.accountExists");
          return;
        }
      } catch (error) {
        this.iswaitingForBackend = false;

        this.$store.state.visitors.showError = true;
        this.$store.state.visitors.errorMessage = error;
        return;
      }

      let response = await this.createSubTenant(this.spamProtectionAnswer);

      if (response != null && response.value.status == 0) {
        this.iswaitingForBackend = false;
        this.spamProtectionAnswer.sum = 0;

        this.resetData();
        this.$refs.form.reset();

        this.$router.push({ name: "registerConfirmed" });
      } else {
        if (response == null) {
          this.$store.state.visitors.errorMessage = "cannot communicate with server!";
        } else {
          this.$store.state.visitors.errorMessage = response.value.responseMessage;
        }
        this.$store.state.visitors.showError = true;
      }

      // stop spinner
      this.iswaitingForBackend = false;
    },
    spamProtectionAnswerChanged() {
      this.spamProtectionAnswerValid = this.spamProtectionEntry == this.spamProtectionAnswer.summandLeft + this.spamProtectionAnswer.summandRight;
      if (this.spamProtectionAnswerValid) {
        this.spamProtectionAnswer.sum = this.spamProtectionEntry;
      }
    },
  },
};
</script>

<style>
.v-label.v-label--active {
  font-size: 22px;
}

.v-select__selections {
  margin-top: 10px;
}

.rafiTextField {
  border-radius: 0px;
}
</style>
